import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { isTenantDomain, getMainDomainUrl } from 'src/utils/domainContext';

// ------------------------------------------------
// MAIN-DOMAIN-ONLY GUARD
// Wraps routes that should only be accessible on the
// main/marketing domain (merudesk.com, localhost).
// If the visitor is on a tenant subdomain, hard-redirect
// them to the main domain equivalent path.
// ------------------------------------------------
export default function MainDomainOnly({ children }) {
  const onTenant = isTenantDomain();

  useEffect(() => {
    if (onTenant) {
      // Hard redirect — we cannot use React Router because
      // the main domain is a different origin / port.
      window.location.href = getMainDomainUrl(window.location.pathname);
    }
  }, [onTenant]);

  // While redirecting, render nothing
  if (onTenant) {
    return null;
  }

  return <>{children}</>;
}

MainDomainOnly.propTypes = {
  children: PropTypes.node,
};
